import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import tool from "./tool";
import pager from '@/components-v2/pager/index.vue';
import publicMethods from '@mixin/publicMethods';
export default {
  components: {
    pager: pager
  },
  data: function data() {
    return {
      searchVal: "",
      total: 0,
      current: 1,
      // 页码
      perPage: 5,
      rangeBefore: 3,
      rangeAfter: 2,
      timerList: [],
      pageInfo: {
        total: null,
        pageNum: 1,
        pageSize: 50
      }
    };
  },
  mixins: [publicMethods],
  created: function created() {
    this.current = 1;
    this.getList();
  },
  methods: {
    // 分页
    getDataByPage: function getDataByPage(pageNum) {
      this.current = pageNum;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, data, result, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/pjyy-deepexi-product-center/api/v1/product/drug/drugList";
              data = {
                page: _this.current,
                size: _this.perPage,
                condition: _this.searchVal
              };
              _context.next = 4;
              return _this.$getHttpClient().post(url, data);
            case 4:
              result = _context.sent;
              _this.productInformationList = result.data.data.list;
              for (i in _this.productInformationList) {
                _this.productInformationList[i].downType = 1;
                _this.productInformationList[i].isShowDown = true;
              }
              _this.pageInfo.total = result.data.data.total;
              _this.pageInfo.pageNum = result.data.data.pageNum;
              _this.pageInfo.pageSize = result.data.data.pageSize;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSearch: function onSearch() {
      this.current = 1;
      this.getList();
    },
    handleChange: function handleChange(val) {
      this.current = val;
      this.getList();
    },
    goDetail: tool.throttle(function (commodityInfo) {
      this.timerList = [];
      this.$buefy.toast.open({
        message: "请稍等！正在下载中",
        type: "is-success",
        position: 'is-bottom'
      });
      this.downloadProductInformation([commodityInfo[0].productCode]);
    })
  }
};